import { request } from "./shared/api";

window.addEventListener('load', () => {
  function hover(this: HTMLElement, open: boolean) {
    open ||= this.matches(':focus-within');
    if (this.classList.contains('open') === open) return;
    const h = getComputedStyle(this.querySelector('.expandable--content > div')!).height;
    const content = this.querySelector<HTMLElement>('.expandable--content')!;
    content.style.height = h;
    content.style.overflow = 'hidden';
    this.classList.toggle('open', open);
    if (!open) setTimeout(function() { content.style.height = ''; }, 1);
    content.scrollTop = 0;
  }
  function end(this: HTMLElement) {
    const content = this.querySelector<HTMLElement>('.expandable--content')!;
    content.style.height = this.classList.contains('open') ? 'auto' : '';
    content.style.overflow = '';
  }
  function focus(this: HTMLElement, e: FocusEvent) {
    // relatedTarget = previous element
    if (!e.relatedTarget || !this.contains(e.relatedTarget as Node)) hover.call(this, true);
  }
  function blur(this: HTMLElement, e: FocusEvent) {
    // relatedTarget = new element
    if (!this.contains(e.relatedTarget as Node)) hover.call(this, false);
  }

  for (const ex of document.querySelectorAll<HTMLElement>('.expandable')) {
    if (ex.classList.contains('no-data')) continue;
    ex.addEventListener('mouseenter', hover.bind(ex, true));
    ex.addEventListener('mouseleave', hover.bind(ex, false));
    ex.addEventListener('focus', focus.bind(ex), {capture:true});
    ex.addEventListener('blur', blur.bind(ex), {capture:true});
    ex.addEventListener('transitionend', end.bind(ex));
  }

  for (const button of document.querySelectorAll<HTMLButtonElement>('.live-refresh')) {
    button.addEventListener('click', async e => {
      e.preventDefault();
      button.disabled = true;
      const typ = button.dataset.type || 'image';
      const img = button.parentElement!.querySelector('img')!;
      const src = new URL(img.src);
      if (typ == 'image') img.src = '';

      try {
        await request(`/live_refresh/${typ.replace('/', '')}/id=${button.dataset.cam!.replace('/', '')}`, {
          method: 'PUT',
        });
      } catch (err: any) {
        console.error(err);
        alert(err.message || err);
      } finally {
        button.disabled = false;
        if (typ != 'image') return;
        src.searchParams.set('t', Math.random().toString().slice(2));
        img.src = src.toString(); // new request, should return new image
      }
    });
  }
});
